<template>
  <div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-md-2 remove">
          <label for ="noofprint">Number of QR:</label>
          <InputNumber  v-model="noToPrintqr" id="noofprint"/>
      </div>
      <div class="p-field p-col-12 p-md-2 p-mt-5 remove">
        <Button class="p-button-raised p-button-success" label="Print" @click.prevent="setArraylength"/>
      </div>
      <div class="p-field p-col-12 p-md-4 p-mt-5"></div>
      <div class="p-field p-col-12 p-md-2">
       <Button class="p-button-raised p-button-secondary btn" @click.prevent="generateQR" label="Print" icon="pi pi-print"/>
      </div>
      <div class="p-field p-col-12 p-md-2">
       <Button class="p-button-raised p-button-danger btn" @click.prevent="$router.back()" label="Cancel"/>
     </div>
   </div>
     <Card>
       <template #content>
         <div class="p-fluid p-formgrid p-grid">
             <div  v-for="itm in testArray" style="margin-top:-3">
               <!-- <qrcode-vue  :value="value" :size="size" level="H" >
               </qrcode-vue> -->
               <barcode v-bind:value="value" >
                 
                </barcode>
               <!-- <div style="margin-bottom: 10%;font-size:75%;">{{value}}</div> -->
             </div>
          </div>
      </template>
   </Card>
  </div>
</template>
<script>
import Card from 'primevue/card'
import Button from 'primevue/button'
import QrcodeVue from 'qrcode.vue'
import VueBarcode from 'vue-barcode'
import InputNumber from 'primevue/inputnumber'
export default {
  name: 'Qrcode',
  props: ['qrData'],
  data() {
    return {
      value: '',
      bar: 'abc',
      size: 40,
      testArray: [],
      noToPrintqr: null
    }
  },
  mounted() {
    this.setQrValue()
  },
  methods: {
    generateQR() {
      window.print()
    },
    setQrValue() {
      if (this.qrData === undefined) {
        this.$router.back()
        return
      }
      this.value = this.qrData.name + '-' + this.qrData.itemCode + '-' + this.qrData.salesRate
    },
    setArraylength() {
      if (this.noToPrintqr > 100) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Number of QR to print cannot be more than 100!', life: 5000})
        return
      }
      var noOfTimesToPrintQr = []
      noOfTimesToPrintQr.length = this.noToPrintqr
      this.testArray = noOfTimesToPrintQr
      this.noToPrintqr = null
    }
  },
  components: {
    Card,
    Button,
    QrcodeVue,
    'barcode': VueBarcode,
    InputNumber
  }
}
</script>
<style scoped>
@media print {
    .btn {
      display: none;
    }
}
@media print {
  .remove {
    display: none
  }
}
.p-field.p-grid, .p-formgrid.p-grid {
    margin-top: 0;
    /* margin-right: 0%; */
    margin-left: 20%;
    /* margin-top: 0%; */
    margin-bottom: 0%;
}
.svg {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// QrCode.vue?0a6482f0